






































import {
  defineComponent,
  defineAsyncComponent,
  computed,
  PropType,
  getCurrentInstance,
} from '@vue/composition-api';
import type {
  ApplyChannelData,
  ApplyProductData,
} from '@/api/apply-product/types';
import { ChannelDisableEnum, RouteMarketEnum } from '@/api/apply-product/types';
import {
  Select,
  SelectOptionType,
  Toast,
  Tag,
} from '@hb/coffee';

const SelectView = defineAsyncComponent(() => Promise.resolve(Select.view));

export default defineComponent({
  name: 'SelectChannelView',
  components: {
    SelectView,
    Tag,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    channelList: {
      type: Array as PropType<ApplyChannelData[]>,
      default: () => [],
    },
    channel: {
      type: Object as () => ApplyChannelData,
      default: () => null,
      required: true,
    },
    product: {
      type: Object as () => ApplyProductData,
      default: () => null,
      required: true,
    },
    switchChannelOpenRemindPopup: {
      type: Function,
      default: () => () => Promise.resolve(false),
    },
  },
  emits: ['cancel', 'updateSelectChannel', 'updateVisible'],
  setup(props, context) {
    const instance = getCurrentInstance();
    const productName = computed(() => props.channel?.productName);

    // 渠道列表
    const selectChannelOptions = computed(() => props.channelList.map((item, index) => ({
      key: item.productId,
      value: `${item.productName}可借${Number(item.availableAmount)}元`,
      index,
      marketingDesc: item.marketingDesc,
      disabled: item.disabled === ChannelDisableEnum.NOT_AVAILABLE,
    })));

    // 选中渠道值
    const defaultSelectChannelValues = computed(() => props.channel?.productId || '');

    // 获取渠道备注信息
    const channelNotes = computed(() => {
      const { routeMarket } = props.channel || {};
      const { notes } = (props.product && props.product.productInfo) || {};
      return routeMarket === RouteMarketEnum.SERIAL ? '最终放款机构以放款结果为准' : (notes || '');
    });

    // 获取选中渠道完整信息
    const getSelectChannel = (key: SelectOptionType['key']) => props.channelList.find((item) => item.productId === key) as ApplyChannelData;

    // 渠道选中前检查
    const onBeforeChecked = async (checkedOption: SelectOptionType) => {
      const selectedChannel = getSelectChannel(checkedOption.key);

      // 推荐渠道挽留
      if (await props.switchChannelOpenRemindPopup(selectedChannel)) {
        context.emit('updateVisible', false);
        return false;
      }

      // 更新选中渠道
      context.emit('updateSelectChannel', selectedChannel);
      return true;
    };

    const onOptionClick = (option: SelectOptionType) => {
      const selectedChannel = getSelectChannel(option.key);
      if (instance?.proxy) {
        instance.proxy.$ubtPageButton(
          '臻有钱_提现申请_选择提现渠道',
          'commodityId',
          selectedChannel && selectedChannel.productId,
          'status',
          `${selectedChannel && selectedChannel.disabledStatus}`,
        );
      }

      // 不可用渠道提示
      if (selectedChannel.disabled === ChannelDisableEnum.NOT_AVAILABLE) {
        Toast(selectedChannel.alertMsg);
      }
    };

    const onCancel = () => {
      context.emit('cancel');
    };

    return {
      productName,
      selectChannelOptions,
      defaultSelectChannelValues,
      onBeforeChecked,
      onCancel,
      channelNotes,
      onOptionClick,
    };
  },
});
